import { Container, Divider } from "@material-ui/core";
import { Box } from "@mui/material";
import {
  ArrayChip,
  ArrayTagChip,
  CurrencyDisplay,
  CustomTable,
  Page,
  PrimaryButton,
  SecondaryButton,
  SongUsageTrendChart,
  SongUsageTrendSummarytCard,
} from "components";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { HeaderTitle } from "layouts";
import { useRef, useState } from "react";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { globalStyles } from "styles";
import { getCookie } from "utils";

const PrintReportReview = () => {
  const classes = globalStyles();
  const history = useHistory();
  const { state } = useLocation();
  const inputRef = useRef(null);
  const userLogin = getCookie("auth", `${process.env.REACT_APP_NAME}_user`);
  const roleComposer = userLogin?.role?.type === "composer";
  const roleSociety = userLogin?.role?.type === "society";
  const [loadingButton, setLoadingButton] = useState(false);
  const { dataTable, chartData, chartReport, selectedDSP } = state;

  const generatePdf = async () => {
    const element = inputRef.current;

    await document.fonts.ready;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: "a4",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * pageWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);
    pdf.save("Review of Song Usage.pdf");
  };
  const handlePrintPDF = async () => {
    setLoadingButton(true);
    await generatePdf();
    setLoadingButton(false);
  };
  
  return (
    <Page className={classes.root} title="Review of Song Usage">
      <Container maxWidth={false} id="content-to-print" ref={inputRef}>
        <HeaderTitle title="Review of Song Usage" />
        <Divider className={classes.divider} />
        <Box border="1px solid #ebebeb" borderRadius="5px" p="50px 20px">
          <Box mb={2}>
            {selectedDSP?.length > 0 && (
              <ArrayTagChip
                selectionsList={
                  selectedDSP.some(item => item.dsp_id === "all")
                    ? [{ dsp_id: "all", name: "All" }]
                    : selectedDSP
                }
                value="name"
              />
            )}
          </Box>
          <SongUsageTrendChart chartData={chartData} preview />
        </Box>
        <SongUsageTrendSummarytCard chartReport={chartReport} />
        <CustomTable
          columnTable={columnTable({ roleComposer, roleSociety })}
          data={dataTable || []}
          maxHeight="100%"
          tableSize="medium"
        />
      </Container>
      <Box justifyContent="flex-end" display="flex" gap={1} m={3}>
        <SecondaryButton label="Back" onClick={() => history.goBack()} />
        <PrimaryButton
          label={loadingButton ? "Please Wait ..." : "Print Report"}
          loading={loadingButton}
          disabled={loadingButton}
          onClick={handlePrintPDF}
        />
      </Box>
    </Page>
  );
};
const columnTable = ({ roleComposer, roleSociety }) => [
  {
    name: roleComposer ? "song_title" : "SongTitle",
    title: "Song Title",
  },
  ...(roleComposer || roleSociety
    ? [
        {
          name: roleSociety ? "ISWC" : "iswc",
          title: "ISWC Code",
        },
      ]
    : []),
  ...(roleComposer
    ? []
    : [
        {
          name: "Composer",
          title: "Composer/Author",
          renderText: item => <ArrayChip list={item} />,
        },
      ]),

  {
    name: roleComposer ? "stream" : "Traffic",
    title: "Traffic",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} />,
  },
  {
    name: roleComposer ? "revenue" : "OriginalCurrencyRevenue",
    title: "Revenue",
    headerAlign: "right",
    renderText: item => (
      <CurrencyDisplay value={item} prefix="Rp " decimalScale={2} />
    ),
  },
  ...(roleComposer || roleSociety
    ? []
    : [
        {
          name: "BaseCurrencyComposerRevenue",
          title: "Composer Revenue",
          headerAlign: "right",
          renderText: item => (
            <CurrencyDisplay value={item} prefix="Rp " decimalScale={2} />
          ),
        },
        {
          name: "BaseCurrencyPublisherRevenue",
          title: "Publisher Revenue",
          headerAlign: "right",
          renderText: item => (
            <CurrencyDisplay value={item} prefix="Rp " decimalScale={2} />
          ),
        },
      ]),
  ...(roleComposer
    ? []
    : [
        {
          name: "ProductType",
          title: "Product Type",
        },
      ]),
];

export default PrintReportReview;
